// @ts-nocheck

import { fill } from 'lodash';
import React from 'react';
import styled, { css } from 'styled-components';

const WIDTH_POINT = 10;
const MARGIN_POINT = 4;

const Wrap = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${WIDTH_POINT + MARGIN_POINT * 2}px;
  display: flex;
  align-items: center;
  @media screen and (max-width: 400px) {
    height: ${WIDTH_POINT / 2 + (MARGIN_POINT / 2) * 2}px;
  }
`;

const Move = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: absolute;
  left: calc(50% - 7px);
  transition: transform 300ms ease-out;
  ${({ $offset }) => css`
    transform: translateX(-${$offset * (WIDTH_POINT + MARGIN_POINT * 2)}px);
    @media screen and (max-width: 400px) {
      transform: translateX(-${$offset * (WIDTH_POINT / 2 + (MARGIN_POINT / 2) * 2)}px);
    }
  `}
`;

const Round = styled.div`
  width: ${WIDTH_POINT}px;
  height: ${WIDTH_POINT}px;
  min-width: ${WIDTH_POINT}px;
  min-height: ${WIDTH_POINT}px;
  margin: ${MARGIN_POINT}px;
  border-radius: 50%;
  background-color: #fff;
  transition: none 300ms ease-out;
  transition-property: transform, opacity;

  ${({ $isFocus }) =>
    $isFocus
      ? css`
          transform: scale(1.6);
          opacity: 1;
        `
      : css`
          transform: scale(1);
          opacity: 0.7;
        `}
  @media screen and (max-width: 400px) {
    width: ${WIDTH_POINT / 2}px;
    height: ${WIDTH_POINT / 2}px;
    min-width: ${WIDTH_POINT / 2}px;
    min-height: ${WIDTH_POINT / 2}px;
    margin: ${MARGIN_POINT / 2}px;
  }
`;

type Props = {
  current: number;
  length: number;
  className?: string;
};

const SwipeReperes = ({ current, length, className }: Props) => (
  <Wrap className={className}>
    <Move $offset={current}>
      {fill(Array(length), true).map((_, index) => (
        <Round key={index} $isFocus={current === index} />
      ))}
    </Move>
  </Wrap>
);

export default SwipeReperes;
